// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1P3yU","colMin":"styles_colMin__1iCBS"};